import * as React from 'react';
import {
	HomePageWrapper,
	SectionContent,
	SectionWrapper,
	Wrapper
} from './HomePageStyles';
import {language} from './HomePageLanguage';
import {
	GeneralViewPortLayout,
	Props as GeneralViewPortProps
} from "../../Components/GeneralViewPort/GeneralViewPortLayout";
import {
	FeatureSectionLayout,
	Props as FeatureSectionProps
} from "./Layouts/FeatureSection/FeatureSectionLayout";
import {
	ServicesLayout,
	Props as ServicesProps
} from "./Layouts/Services/ServicesLayout";
import {servicesSchema} from "../../Schema/HomePage/ServicesSchema";
import {BlurbLayout} from "./Layouts/Blurb/BlurbLayout";
import { ValuePropsSectionLayout, Props as ValuePropsProps } from './Layouts/ValueProps/ValuePropsSectionLayout';
import {EducationLayout} from "./Layouts/Education/EducationLayout";
import {GenericSectionWrapper} from "./Layouts/GenericSection/GenericSectionStyles";
import {GenericSectionLayout} from "./Layouts/GenericSection/GenericSectionLayout";
import {FooterLayout} from "../../Components/Footer/FooterLayout";
import {useMobile} from "../../utils/useMobile";
import { generateGenericSections } from './helpers/generateGenericSections';
import {BulletSectionContainer} from "./Layouts/BulletSection/BulletSectionContainer";
import {BulletSectionLayout} from "./Layouts/BulletSection/BulletSectionLayout";

export type Props = {
	schema: any
};

export const HomePageLayout = (props: Props) =>
{
	const isMobile = useMobile();
	const render = () =>
	{
		const featureSectionProps: FeatureSectionProps = {
			featureSection: props.schema.featureSection
		};

		const valuePropsProps: ValuePropsProps = {
			valuePropsSectionProps: props.schema.valuePropsSection
		};

		const blurbProps = {
			blurbSection: props.schema.blurbSection,
		};

		const educationProps = {
			schema: props.schema.educationSection
		}

		const bulletProps = {
			Layout: BulletSectionLayout,
			schema: props.schema.bulletSection,
		}

		const genericSectionsJSX = generateGenericSections(props.schema.genericSections);

		const internalJSX = (
			<Wrapper>
				<FeatureSectionLayout {...featureSectionProps} />
				<SectionWrapper>
					<SectionContent>
						<BlurbLayout {...blurbProps} />
					</SectionContent>
				</SectionWrapper>
				<SectionWrapper>
					<SectionContent>
						<ValuePropsSectionLayout {...valuePropsProps} />
					</SectionContent>
				</SectionWrapper>
				<SectionWrapper>
					<SectionContent>
						<EducationLayout {...educationProps} />
					</SectionContent>
				</SectionWrapper>
				<SectionWrapper>
					<SectionContent>
						<BulletSectionContainer {...bulletProps} />
					</SectionContent>
				</SectionWrapper>
				{genericSectionsJSX}
				<FooterLayout naked={true} mobile={isMobile} />
			</Wrapper>
		);

		const generalViewPortProps: GeneralViewPortProps = {
			internalJSX
		};

		const returnValue = (
			<HomePageWrapper>
				{internalJSX}
				{/*<GeneralViewPortLayout {...generalViewPortProps} />*/}
			</HomePageWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

